import { render, staticRenderFns } from "./TabsDashboardFleet.vue?vue&type=template&id=0183cd3e&"
import script from "./TabsDashboardFleet.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardFleet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports